import { useCallback, useEffect, useState } from 'react';
import { readPreference, writePreference } from './preferences';

export type ThemePreference = 'system' | 'light' | 'dark';

const ORDER: readonly ThemePreference[] = ['system', 'dark', 'light'];

function apply(theme: ThemePreference): void {
  const root = document.documentElement;
  if (theme === 'system') delete root.dataset.theme;
  else root.dataset.theme = theme;
}

function stored(): ThemePreference {
  const value = readPreference('theme');
  return value === 'light' || value === 'dark' ? value : 'system';
}

/** Applies the persisted theme as early as possible to avoid a flash. */
export const initTheme = (): void => apply(stored());

export function useTheme() {
  const [theme, setTheme] = useState<ThemePreference>(stored);
  useEffect(() => apply(theme), [theme]);
  const cycle = useCallback(() => {
    setTheme((current) => {
      const next = ORDER[(ORDER.indexOf(current) + 1) % ORDER.length]!;
      writePreference('theme', next);
      return next;
    });
  }, []);
  return { theme, cycle };
}
